import React from 'react';
import styles from './RoundSocials.m.sass';

import DiscordIcon from '-!svg-react-loader?name=DiscordIcon!../../assets/images/social/discord.svg';
import SkypeIcon from '-!svg-react-loader?name=SkypeIcon!../../assets/images/social/skype.svg';
import ElvelopeIcon from '-!svg-react-loader?name=ElvelopeIcon!../../assets/images/social/envelope.svg';
import RoundButton from "../roundButton/RoundButton";

export default class RoundSocials extends React.PureComponent {
  render() {
    return (
      <div className={styles.roundSocials}>
        <span className={styles.roundSocials_link}>
          <RoundButton
            component="a"
            href="skype:live:boosters4gamers?chat"
            target="_blank"
            rel="nofollow"
          >
            <SkypeIcon/>
          </RoundButton>
        </span>

        <span className={styles.roundSocials_link}>
          <RoundButton
            component="a"
            href="https://discord.gg/WVYyYuT"
            target="_blank"
            rel="nofollow"
          >
            <DiscordIcon/>
          </RoundButton>
        </span>

        <span className={styles.roundSocials_link}>
          <RoundButton
            component="a"
            href="mailto:bosters4gamers@gmail.com"
            rel="nofollow"
          >
            <ElvelopeIcon/>
          </RoundButton>
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/roundSocials/RoundSocials.js